import angular from 'angular'

import '../controller/controller'

export const Storage = {

// The transient storage is used to store values if session or local storage isn't supported
// session storage isn't supported in private browsing mode in Safari
// If the transient storage is used and the user refreshes the page, their session will be blown away
// This isn't ideal but its the only way to allow users in private browsing mode to use the system
    transientStorage: {},

    isSupported() {
        try {
            // Safari won't allow writing to session or local storage while in private browsing mode.
            // This allows us to determine if it's supported or not and act accordingly
            sessionStorage.setItem("sessionStorage", "1")
            sessionStorage.removeItem("sessionStorage")
            localStorage.setItem("localStorage", "1")
            localStorage.removeItem("localStorage")
            return true
        } catch (err) {
            return false
        }
        return false
    },

    setStorageItem(itemName, itemValue, storage) {
        // Tries to store and retrieve from local storage first
        // If that isn't supported transient storage is used instead
        // if no itemValue is given, it just retrieves from storage
        let stored
        if (this.isSupported()) {
            if (itemValue !== undefined) {
                storage.setItem(itemName, JSON.stringify(itemValue))
            }
            stored = JSON.parse(storage.getItem(itemName))
        } else {
            stored = this.setTransientStorageItem(itemName, itemValue)
        }
        return stored
    },

    setLocalStorageItem(itemName, itemValue) {
        return this.setStorageItem(itemName, itemValue, localStorage)
    },
    setSessionStorageItem(itemName, itemValue) {
        return this.setStorageItem(itemName, itemValue, sessionStorage)
    },

    setTransientStorageItem(itemName, itemValue) {
        if (itemValue !== undefined) {
            this.transientStorage[itemName] = itemValue
        }
        return this.transientStorage[itemName]
    },

    // Using "set" to get item, as a set _optionally_ sets the value if one
    // is provided, but always refetches and returns the fetched value. It
    // also leverages the "transient" storage fallback behaviour.
    getLocalStorageItem(itemName) {
        return this.setStorageItem(itemName, undefined, localStorage)
    },

    // Using "set" to get item, as a set _optionally_ sets the value if one
    // is provided, but always refetches and returns the fetched value. It
    // also leverages the "transient" storage fallback behaviour.
    getSessionStorageItem(itemName) {
        return this.setStorageItem(itemName, undefined, sessionStorage)
    },

    removeLocalStorageItem(itemName) {
        if (this.isSupported()) {
            localStorage.removeItem(itemName)
        } else {
            // don't delete the item from transient storage, instead set it to null
            // otherwise if you try to get it later on, it's value will be undefined
            // however it needs to mimic the behaviour of local storage
            // which actually returns null for items that have been removed from it
            this.transientStorage[itemName] = null
        }
    },
}
export default Storage

angular.module("core.application.main").factory("core.application.main.factory.storage", [() => Storage])
